<div class="row justify-content-center mb-5 pt-4">
  <div class="col-lg-8 col-md-10 login-panel p-5">
    <div class="row justify-content-center">
      <div class="col-lg-7 col-md-9 text-center">
        <div class="mb-4 text-black">
          {{ 'common.pleaseLoginAsInvestor' | translate }}
        </div>
        <div class="btn btn-primary-border w-100 font-size-larger mb-3 py-3" routerLink="/login">
          {{ 'common.loginBtn' | translate }}
        </div>
        <div
          class="btn btn-primary w-100 font-size-larger py-3"
          routerLink="/sign-up"
          data-t="signUpClick"
          data-t-location="page"
        >
          {{ 'common.signUp' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>
